import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FaHome, FaCog, FaInbox,FaComments, FaBell } from 'react-icons/fa';



const SidebarContainer = styled.div`
  width: 200px;
  height: 100vh;
  background-color: white;
  position: fixed;
  top: 70px;
  left: 0; 
  transition: none; 
  padding: 20px;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const SidebarButton = styled.button`
  width: 100%;
  padding: 12px 30px;
  margin-bottom: 10px;
  background-color: white;
  color: Black;
  border: none;
  border-radius: 15px;
  text-align: left;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: all 0.3s ease;

  &:hover {
    background-color: #e0e0e0;
    transform: translateX(4px);
  }

  &:active {
    transform: translateX(2px);
  }
      svg {
    flex-shrink: 0;
    margin-right: 12px;
    font-size: 18px;
  }
`;

const SidebarBottom = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px; 
`;

const Sidebar = () => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate(path);
  };


  return (
    <SidebarContainer>
      <SidebarBottom>
        <SidebarButton onClick={() => handleClick('/Dashboard')}>
          <FaHome style={{ marginRight: '10px' }} />
          Home
        </SidebarButton>
        <SidebarButton onClick={() => handleClick('/home')}>
          <FaComments style={{ marginRight: '10px', fontSize: '18px' }} />
          Reviews
        </SidebarButton>
        <SidebarButton onClick={() => handleClick('/inbox')}>
          <FaBell style={{ marginRight: '10px', fontSize: '18px' }} />
          Notifications
        </SidebarButton>
        <SidebarButton onClick={() => handleClick('/settings')}>
          <FaCog style={{ marginRight: '10px' }} />
          Settings
        </SidebarButton>
      </SidebarBottom>
    </SidebarContainer>
  );
};

export default Sidebar;